export default {
  lista: [],
  estaCarregando: false,
  todosItensCarregados: false,
  paginaAtual: 1,
  order: '',
  direcao: '',
  itemSelecionadoId: null,
  totalItens: null,
  filtros: {
    aluno: null,
    item: null,
    usuario: null,
    valor_inicial: null,
    valor_final: null,
    data_aula_inicio: null,
    data_aula_fim: null,
    data_saida_inicio: null,
    data_saida_fim: null,
    data_entrega_inicio: null,
    data_entrega_fim: null,
    item_entregue: null,

    turma: null,
    data_inicio: null,
    data_fim: null,
    modalidade_turma: null
  }
}
